"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inheritsFrom = inheritsFrom;

// Check if one JavaScript class inherits from another
function inheritsFrom(Type, ParentType) {
  while (Type) {
    if (Type === ParentType) {
      return true;
    }

    Type = Object.getPrototypeOf(Type);
  }

  return false;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9pbmhlcml0cy1mcm9tLmpzIl0sIm5hbWVzIjpbImluaGVyaXRzRnJvbSIsIlR5cGUiLCJQYXJlbnRUeXBlIiwiT2JqZWN0IiwiZ2V0UHJvdG90eXBlT2YiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTtBQUNPLFNBQVNBLFlBQVQsQ0FBc0JDLElBQXRCLEVBQTRCQyxVQUE1QixFQUF3QztBQUM3QyxTQUFPRCxJQUFQLEVBQWE7QUFDWCxRQUFJQSxTQUFTQyxVQUFiLEVBQXlCO0FBQ3ZCLGFBQU8sSUFBUDtBQUNEOztBQUNERCxXQUFPRSxPQUFPQyxjQUFQLENBQXNCSCxJQUF0QixDQUFQO0FBQ0Q7O0FBQ0QsU0FBTyxLQUFQO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBDaGVjayBpZiBvbmUgSmF2YVNjcmlwdCBjbGFzcyBpbmhlcml0cyBmcm9tIGFub3RoZXJcbmV4cG9ydCBmdW5jdGlvbiBpbmhlcml0c0Zyb20oVHlwZSwgUGFyZW50VHlwZSkge1xuICB3aGlsZSAoVHlwZSkge1xuICAgIGlmIChUeXBlID09PSBQYXJlbnRUeXBlKSB7XG4gICAgICByZXR1cm4gdHJ1ZTtcbiAgICB9XG4gICAgVHlwZSA9IE9iamVjdC5nZXRQcm90b3R5cGVPZihUeXBlKTtcbiAgfVxuICByZXR1cm4gZmFsc2U7XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/@deck.gl/react/dist/utils/inherits-from.js
// module id = 906
// module chunks = 0